import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { pushPage } from '@shared/actions';
import trackProductSearchClicked from '@conversion/tracking/actions/trackProductSearchClicked';
import onSectionHeightUpdated from '@shopDetails/actions/onSectionHeightUpdated';
import getSectionsHeights from '@shopDetails/selectors/getSectionsHeights';
import { getShopBusinessType } from '@shopDetails/selectors';
import getMeasurementUnits from '@shopDetails/selectors/getMeasurementUnits';
import trackBeforePriceProductsLoaded from '@conversion/tracking/actions/trackBeforePriceProductLoaded';
import trackSectionDetailsLoaded from '@conversion/tracking/actions/trackSectionDetailsLoaded';
import getAcceptsPreOrder from '@core/reducers/shop/selectors/getAcceptsPreOrder';
import getShopIsOpen from '@core/reducers/shop/selectors/getShopIsOpen';

import ShelvesLayout from './ShelvesLayout';

const mapStateToProps = createStructuredSelector({
  sectionsHeights: getSectionsHeights,
  businessType: getShopBusinessType,
  measurementItems: getMeasurementUnits,
  shopAcceptsPreOrder: getAcceptsPreOrder,
  shopIsOpen: getShopIsOpen,
});

const mapDispatchToProps = {
  pushPage,
  trackProductSearchClicked,
  onSectionHeightUpdated,
  trackBeforePriceProductsLoaded,
  trackSectionDetailsLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShelvesLayout);
